module.exports = __webpack_public_path__ + "codeorgteacherwpa4469dc978da3470408bbd7941b83dd0.png";